import IndexLayout from '../layouts';
import Wrapper from '../components/Wrapper';
import SiteNav from '../components/header/SiteNav';

import { Button, InputField, Group } from 'fannypack';
import Spinner from '../../src/components/ui/Spinner';

import ReactCompareImage from 'react-compare-image';

import { SiteHeader, outer, inner, SiteMain } from '../styles/shared';
import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { PostFullHeader, PostFullTitle, NoImage, PostFull } from '../templates/post';
import { PostFullContent } from '../components/PostContent';
import Footer from '../components/Footer';
import Helmet from 'react-helmet';

//import ShareButtons from '../components/ShareButtons';
import MoreGoodies from '../components/more-goodies/MoreGoodies';
import BackToTop from '../components/BackToTop';

import random from '../utils/random';

interface CompareWrapperProps {
  thin?: boolean;
}

const CompareWrapper = styled.div<CompareWrapperProps>`
  max-width: ${props => (props.thin ? '750px' : '100%')};
  margin: 0 auto 3rem;
`;

class RerenderCompare extends React.Component {
  t1;
  state = { delayOver: false };

  componentDidMount() {
    this.t1 = setTimeout(() => {
      this.setState({ delayOver: true });
    }, 500);
  }

  componentWillUnmount() {
    clearTimeout(this.t1);
  }

  render() {
    if (!this.state.delayOver) {
      return <Spinner />;
    }
    return this.props.children();
  }
}

const PageTemplate = css`
.site-main {
background #fff;
padding-bottom: 4vw;
}

.post-content {
max-width: 1000px;
margin: -2.5rem auto 0;
}
.post-full-content {
  background: transparent;
}
p {
  font-size: 2rem !important;

}
h2 {
  margin-top: 0;
  font-size: 3rem;

  small {
    font-size: 1.5rem;
    font-weight: normal;
  }
}
h2::before {
all: unset !important;
}
h3 {
text-decoration: none !important;
padding-top: 5rem;
text-align: center;
}

button.active {
  background: #32BA55;
  color: white;
}
`;

const FactsBox = styled.div`
  margin-top: 1.5rem;
  background: #EFFAF2;
  padding: 1.3rem 1.3rem 0.45rem;

  @media (max-width: 750px) {
    padding: 0.1rem 0.1rem 0.1rem;
  }

  li:first-letter {
    color: #ACE3BA;
  }

  h3 {
    padding-top: 0;
  }
`;

const FlexWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: last baseline;
  margin-bottom: 2rem;

  div {
    margin: 1rem 0.75rem;
  }
`;

const TextureWrapper = styled.div`
  background: white;
  overflow: hidden;
  max-height: 75vh;
  margin-bottom: 2.5rem;

  svg {
    max-width: 100%;
    max-height: 600px;
  }
`;
const ControlsWrapper = styled.div`
  // margin: 0 0 1rem;
`;

interface RainTextureGeneratorState {
  width: number;
  height: number;
  pendingDownload: boolean;
  seed: number;
  density: string;
  density2: string;
}

class RainTextureGenerator extends React.Component<undefined, RainTextureGeneratorState> {
  state = {
    width: 1000,
    height: 600,
    pendingDownload: false,
    seed: 1,
    density: 'low',
    density2: 'high',
  };

  canvasRef;
  textureRef;

  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
    this.textureRef = React.createRef();
  }

  newSeed = () => {
    const seed = random(1, 1000);
    this.setState({ seed });
  };

  handleWidthChange = e => {
    if (!+e.target.value || +e.target.value > 10000) {
      return;
    }

    this.setState({ width: +e.target.value });
  };

  handleHeightChange = e => {
    if (!+e.target.value || +e.target.value > 10000) {
      return;
    }

    this.setState({ height: +e.target.value });
  };

  // help from: http://dinbror.dk/blog/how-to-download-an-inline-svg-as-jpg-or-png/
  // help from: https://javascript.info/blob#blob-to-base64
  generateDownloadable = () => {
    this.setState({ pendingDownload: true });
    const { width } = this.state;

    const canvas = this.canvasRef.current;
    const texture = this.textureRef.current;

    // Sept. 2019: for now it has to be same width/height, bug in Safari when very large and not square
    texture.setAttribute('width', width);
    texture.setAttribute('height', width);

    const xml = new XMLSerializer().serializeToString(texture);
    const svg64 = btoa(xml);
    const b64Start = 'data:image/svg+xml;base64,';
    const image = new Image();
    image.src = b64Start + svg64;

    const ctx = canvas.getContext('2d');
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, width, width);

    image.onload = () => {
      ctx.drawImage(image, 0, 0, width, width);

      canvas.toBlob(
        blob => {
          const link = document.createElement('a');
          link.download = 'cloud-texture.jpg';

          link.href = URL.createObjectURL(blob);
          link.click();
          URL.revokeObjectURL(link.href);

          texture.setAttribute('width', 1000);
          texture.setAttribute('height', 600);
          this.setState({ pendingDownload: false });
        },
        'image/jpeg',
        0.9,
      );
    };
  };

  render() {
    return (
      <IndexLayout>
        <Helmet>
          <title>Rain Texture Generator for Retouching | Giggster Guide</title>
          <meta
            name="description"
            content="With this tool you can generate textures of rain effects and save them as Jpeg files to use in Photoshop to add rain to your photos."
          />

          <meta property="og:site_name" content="Giggster Guide" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="Rain Texture Generator for Retouching" />
          <meta
            property="og:description"
            content="With this tool you can generate textures of rain effects and save them as Jpeg files to use in Photoshop to add rain to your photos."
          />
          <meta property="og:url" content="https://giggster.com/guide/rain-texture-generator/" />
          <meta
            property="og:image"
            content="https://giggster.com/guide/covers/rain-texture-generator.jpg"
          />
          <meta property="article:publisher" content="https://www.facebook.com/giggsterHQ" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Rain Texture Generator for Retouching" />
          <meta
            name="twitter:description"
            content="With this tool you can generate textures of rain effects and save them as Jpeg files to use in Photoshop to add rain to your photos."
          />
          <meta name="twitter:url" content="https://giggster.com/guide/rain-texture-generator/" />
          <meta
            name="twitter:image"
            content="https://giggster.com/guide/covers/rain-texture-generator.jpg"
          />
          <meta name="twitter:site" content="@Giggster" />
          <meta name="twitter:creator" content="@Giggster" />
        </Helmet>
        <Wrapper css={PageTemplate}>
          <header css={[outer, SiteHeader]}>
            <div css={inner}>
              <SiteNav />
            </div>
          </header>
          <main id="site-main" className="site-main" css={[SiteMain, outer]}>
            <article className="post page" css={[PostFull, NoImage]}>
              <PostFullHeader>
                <PostFullTitle>Rain Texture Generator</PostFullTitle>
                <p className="t2">
                  An simple tool to generate seamless rain textures to use to add realistic-looking
                  rain to your photos using a software like Adobe Photoshop
                </p>
                {/*<ShareButtons
                  title={'Rain Texture Generator'}
                  slug={'/rain-texture-generator/'}
                  imgSrc={'covers/rain-texture-generator.jpg'}
                />*/}
              </PostFullHeader>

              <PostFullContent className="post-full-content">
                <div className="post-content text-center">
                  <ControlsWrapper>
                    <div>
                      <FlexWrapper>
                        <FlexWrapper>
                          Style:
                          <Group>
                            <Button
                              className={`${this.state.density === 'low' ? 'active' : ''}`}
                              size="small"
                              // tslint:disable-next-line:react-this-binding-issue
                              onClick={() => this.setState({ density: 'low' })}
                            >
                              One
                            </Button>
                            <Button
                              className={`${this.state.density === 'medium' ? 'active' : ''}`}
                              size="small"
                              // tslint:disable-next-line:react-this-binding-issue
                              onClick={() => this.setState({ density: 'medium' })}
                            >
                              Two
                            </Button>
                            <Button
                              className={`${this.state.density === 'high' ? 'active' : ''}`}
                              size="small"
                              // tslint:disable-next-line:react-this-binding-issue
                              onClick={() => this.setState({ density: 'high' })}
                            >
                              Three
                            </Button>
                          </Group>
                        </FlexWrapper>
                        <FlexWrapper>
                          Density:
                          <Group>
                            <Button
                              className={`${this.state.density2 === 'low' ? 'active' : ''}`}
                              size="small"
                              // tslint:disable-next-line:react-this-binding-issue
                              onClick={() => this.setState({ density2: 'low' })}
                            >
                              Low
                            </Button>
                            <Button
                              className={`${this.state.density2 === 'medium' ? 'active' : ''}`}
                              size="small"
                              // tslint:disable-next-line:react-this-binding-issue
                              onClick={() => this.setState({ density2: 'medium' })}
                            >
                              Medium
                            </Button>
                            <Button
                              className={`${this.state.density2 === 'high' ? 'active' : ''}`}
                              size="small"
                              // tslint:disable-next-line:react-this-binding-issue
                              onClick={() => this.setState({ density2: 'high' })}
                            >
                              High
                            </Button>
                          </Group>
                        </FlexWrapper>
                      </FlexWrapper>
                    </div>
                  </ControlsWrapper>
                  <TextureWrapper>
                    <h2>Rain Texture Preview</h2>
                    <svg
                      onClick={this.newSeed}
                      style={{ cursor: 'pointer' }}
                      width="1000"
                      height="600"
                      ref={this.textureRef}
                    >
                      <filter id="texture" x="0%" y="0%" width="100%" height="100%">
                        <feTurbulence
                          type="turbulence"
                          baseFrequency={
                            this.state.density === 'low'
                              ? '0.181 0.01'
                              : this.state.density === 'medium'
                              ? '0.4 0.01'
                              : '0.25 0.009'
                          }
                          numOctaves="4"
                          seed={this.state.seed}
                          result="NOISE"
                          stitchTiles="stitch"
                        />
                        <feColorMatrix
                          type="matrix"
                          values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
                          in="NOISE"
                          result="BNW"
                        />
                        <feComponentTransfer result="componentTransfer1">
                          <feFuncR type="table" tableValues="0 0 0 0 0.2 0.4 0.6 0.8 1" />
                          <feFuncG type="table" tableValues="0 0 0 0 0.2 0.4 0.6 0.8 1" />
                          <feFuncB type="table" tableValues="0 0 0 0 0.2 0.4 0.6 0.8 1" />
                          <feFuncA type="table" tableValues="1 1 1 1 1 1 1 1 1" />
                        </feComponentTransfer>
                        <feComponentTransfer in="componentTransfer1" result="GRADIENTMAP">
                          <feFuncR type="table" tableValues="1 0" />
                          <feFuncG type="table" tableValues="1 0" />
                          <feFuncB type="table" tableValues="1 0" />
                          <feFuncA type="table" tableValues="0 1" />
                        </feComponentTransfer>
                        <feColorMatrix
                          in="GRADIENTMAP"
                          result="INVERTED"
                          type="matrix"
                          values="-1 0 0 0 1
                                    0 -1 0 0 1
                                    0 0 -1 0 1
                                    0 0 0 1 0"
                        />
                        <feFlood floodColor="black" result="BLACK" />
                        <feBlend
                          mode="soft-light"
                          in="BLACK"
                          in2="INVERTED"
                          result="FINAL-BEFORE-EXTRA-DENSITY"
                        />

                        {this.state.density2 === 'high' && (
                          <>
                            <feFlood floodColor="rgba(0,0,0,0.75)" result="BLACK2" />
                            <feBlend
                              mode="soft-light"
                              in="BLACK2"
                              in2="FINAL-BEFORE-EXTRA-DENSITY"
                            />
                          </>
                        )}

                        {this.state.density2 === 'medium' && (
                          <>
                            <feFlood floodColor="black" result="BLACK2" />
                            <feBlend
                              mode="soft-light"
                              in="BLACK2"
                              in2="FINAL-BEFORE-EXTRA-DENSITY"
                            />
                          </>
                        )}
                        {this.state.density2 === 'low' && (
                          <>
                            <feFlood floodColor="rgba(0,0,0,0.5)" result="BLACK2" />
                            <feBlend
                              mode="soft-light"
                              in="BLACK2"
                              in2="FINAL-BEFORE-EXTRA-DENSITY"
                              result="MEDIUM-DENSITY"
                            />
                            <feFlood floodColor="black" result="BLACK3" />
                            <feBlend mode="soft-light" in="BLACK3" in2="MEDIUM-DENSITY" />
                          </>
                        )}
                      </filter>

                      <rect
                        x="0"
                        y="0"
                        width="100%"
                        height="100%"
                        filter={`url(#texture)`}
                        fill="none"
                      />
                    </svg>
                  </TextureWrapper>
                  <FlexWrapper>
                    <InputField
                      a11yId="long-edge"
                      // size="medium"
                      label="Size of long edge (in px)"
                      type="number"
                      value={`${this.state.width.toString()}`}
                      onChange={this.handleWidthChange}
                    />
                    {/* <InputField
                      a11yId="height"
                      // size="medium"
                      label="Height (in px)"
                      type="number"
                      value={`${this.state.height.toString()}`}
                      onChange={this.handleHeightChange}
                    /> */}
                    {this.state.pendingDownload ? (
                      <Spinner />
                    ) : (
                      <Button palette="primary" onClick={this.generateDownloadable}>
                        Download Texture
                      </Button>
                    )}
                  </FlexWrapper>

                  <hr />

                  <FactsBox>
                    <h3>How it works</h3>
                    <ul>
                      <li>
                        &#9673; Play with the settings to get different variations of rain texture.
                        Click on the texture preview to get another random variation using the
                        selected settings.
                      </li>
                      <li>
                        &#9673; The exported texture will be seamless and you can stitch multiple of
                        the same texture side by side if needed. Or you can just choose to export a
                        texture file large enough to cover your whole image.
                      </li>
                      <li>
                        &#9673; To apply the texture in Photoshop, add the texture as a new layer,
                        change the blend mode of the texture layer to <em>Screen</em>, rotate the
                        whole texture layer so that the rain comes at your desired angle, and adjust
                        the opacity so that the texture blends well with the photograph.
                      </li>
                      <li>
                        &#9673; It's a good idea to hide the texture in the dark areas of the
                        photograph, for a more realistic effect. You can see how to do that in the
                        example below.
                      </li>
                    </ul>
                  </FactsBox>

                  <hr />

                  <h2>Rain Texture Usage Example</h2>
                  <CompareWrapper>
                    <RerenderCompare>
                      {() => (
                        <ReactCompareImage
                          sliderPositionPercentage={0.5}
                          leftImage="/images/rain-texture-generator/rain-texture-before.jpg"
                          rightImage="/images/rain-texture-generator/rain-texture-after.jpg"
                          sliderLineWidth={4}
                          skeleton={<Spinner />}
                        />
                      )}
                    </RerenderCompare>
                  </CompareWrapper>

                  <p>
                    As you can see from the above example, the effect is subtle, but still present
                    and gives an even more "gloomy day" feel to the photo. In that example, the
                    opacity of the texture layer was reduced to 70%.
                  </p>

                  <p>
                    In addition to the above steps to integrate the texture (change the blend mode
                    to screen, rotate the layer, change the opacity), I've also made sure that the
                    texture doesn't show in darker parts of the image. There are two easy ways to do
                    that in Photoshop: <em>Using Apply Image on a mask</em> or{' '}
                    <em>Using Blend If</em>. Next is a breakdown of how to use either of those
                    methods.
                  </p>

                  <h3>Apply Image</h3>

                  <p>
                    To use this first method of hiding the rain texture in the dark parts of the
                    image, add a mask to the texture layer, then go to{' '}
                    <em>Image &gt; Apply Image...</em> This will add a copy of the image's
                    underlining luminosity values to the mask, effectively hiding the darker
                    portions of the layer.
                  </p>

                  <figure className="text-center screenshot">
                    <img
                      src="/images/rain-texture-generator/rain-texture-generator00.jpg"
                      alt="Using Apply Image"
                    />
                  </figure>

                  <h3>Blend If</h3>

                  <p>
                    With this second option, you have more control over exactly where the texture is
                    hidden. To use this second option, right-click on the texture layer and select{' '}
                    <em>Blending Options...</em> In the <em>Underlining layer</em> slider of the{' '}
                    <em>Blending If</em> section, move the dark point to prevent the layer from
                    showing up in the dark areas. Hold the <em>Alt/Option</em> key as you move the
                    dark point to separate the 2 small triangles, allowing you to feather the
                    effect.
                  </p>

                  <figure className="text-center screenshot">
                    <img
                      src="/images/rain-texture-generator/rain-texture-generator01.jpg"
                      alt="Using Blend If"
                    />
                  </figure>
                </div>
              </PostFullContent>
            </article>
            <MoreGoodies slug="rain-texture-generator" />
          </main>
          <BackToTop />
          <Footer />
        </Wrapper>
        <canvas
          ref={this.canvasRef}
          width={this.state.width}
          height={this.state.width}
          style={{
            width: `${this.state.width}px`,
            height: `${this.state.width}px`,
            maxWidth: 'none',
            maxHeight: 'none',
            display: 'none',
          }}
        />
      </IndexLayout>
    );
  }
}

export default RainTextureGenerator;
